import React, { useCallback } from 'react';
import { IDResource } from 'types';
import { formatLink } from 'utils/helpers/resourcesMap';
import './index.scss';

interface ResourceLinkProps {
  r: IDResource;
  svgComponent: JSX.Element;
  onElementHover: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  onElementLeave: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  onElementClick: () => void;
}

const ResourceLink: React.FC<ResourceLinkProps> = ({
  r,
  svgComponent,
  onElementHover,
  onElementLeave,
  onElementClick,
}) => {
  // const onElementClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
  //   const el = e.target;
  //   console.log('ResourceLink onElementClick el', el);
  //   // const { index } = el;

  //   window.open(formatLink(r.link), '_blank');
  // };

  const handleMouseOver = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      onElementHover(event);
    },
    [onElementHover]
  );
  const handleMouseLeave = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      onElementLeave(event);
    },
    [onElementLeave]
  );

  if (!r || !svgComponent) {
    return null;
  }

  return (
    <a
      href={formatLink(r.link)}
      onMouseOver={handleMouseOver}
      onFocus={() => null}
      onMouseLeave={handleMouseLeave}
      onClick={onElementClick}
      target="_blank"
      rel="noreferrer"
    >
      {svgComponent}
    </a>
  );
};

export default ResourceLink;
